import { render, staticRenderFns } from "./CertImage.vue?vue&type=template&id=162f8a3b&"
import script from "./CertImage.vue?vue&type=script&lang=js&"
export * from "./CertImage.vue?vue&type=script&lang=js&"
import style0 from "./CertImage.vue?vue&type=style&index=0&id=162f8a3b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports